export default {
  List: "/pyr/email-templates",
  Create: "/pyr/email-templates",
  Update: "/pyr/email-templates",
  Detail: "/pyr/email-templates",
};
